import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Add loading class to body initially
document.body.classList.add('loading');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Remove loading class after initial render
setTimeout(() => {
  document.body.classList.remove('loading');
  document.documentElement.classList.add('loaded');
}, 100);
